export default "__VITE_ASSET__B_HA4ONR__"